var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransporteTaxiRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "r9uic741hb",
    d: "M0 0L24 0 24 20.125 0 20.125z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M7.623 1.917h3.954c.499 0 .903-.43.903-.959 0-.529-.404-.958-.903-.958H7.623c-.499 0-.903.43-.903.958 0 .53.404.959.903.959",
    transform: "translate(2.000000, 2.500000)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 2.500000) translate(0.000000, 2.875000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M20.13 6.584H3.87v-.17c0-2.662 2.217-4.828 4.944-4.828h6.372c2.727 0 4.945 2.166 4.945 4.827v.17zm-1.802 6.21c-.663 0-1.201-.525-1.201-1.173 0-.647.538-1.172 1.2-1.172.664 0 1.201.525 1.201 1.172 0 .648-.537 1.172-1.2 1.172zm-12.656 0c-.663 0-1.2-.525-1.2-1.173 0-.647.537-1.172 1.2-1.172.663 0 1.2.525 1.2 1.172 0 .648-.537 1.172-1.2 1.172zm16.134-6.21h-.05v-.17c0-3.537-2.947-6.414-6.57-6.414H8.814c-3.623 0-6.57 2.877-6.57 6.413v.17h-.05C.984 6.584 0 7.546 0 8.727v5.784c0 1.18.984 2.142 2.194 2.142h.286v2.68c0 .438.364.793.812.793.449 0 .813-.355.813-.793v-2.68h15.79v2.68c0 .438.364.793.813.793.448 0 .812-.355.812-.793v-2.68h.286c1.21 0 2.194-.961 2.194-2.142V8.726c0-1.181-.984-2.142-2.194-2.142z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporteTaxiRed);
export default __webpack_public_path__ + "static/media/transporteTaxiRed.32cc9b42.svg";
export { ForwardRef as ReactComponent };